import { getRng } from './utils/random';

const shuffle = (array, rng) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const isValid = (board, row, col, num) => {
  for (let x = 0; x < 9; x++) {
    if (board[row][x] === num || board[x][col] === num) return false;
    const boxRow = 3 * Math.floor(row / 3) + Math.floor(x / 3);
    const boxCol = 3 * Math.floor(col / 3) + (x % 3);
    if (board[boxRow][boxCol] === num) return false;
  }
  return true;
};

const fillBoard = (board, rng) => {
  for (let row = 0; row < 9; row++) {
    for (let col = 0; col < 9; col++) {
      if (board[row][col] === 0) {
        const nums = shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9], rng);
        
        for (let num of nums) {
          if (isValid(board, row, col, num)) {
            board[row][col] = num;
            if (fillBoard(board, rng)) return true;
            board[row][col] = 0;
          }
        }
        return false;
      }
    }
  }
  return true;
};

export const generateSudoku = (difficulty = 'medium', seed = null) => {
  const rng = getRng(seed);
  let board = Array.from({ length: 9 }, () => Array(9).fill(0));

  fillBoard(board, rng);
  
  const solution = board.map(row => [...row]);

  // ������ هنا قادينا الصعوبات باش تبان الفرق مزيان ������
  let attempts = 45; // Default Medium
  if (difficulty === 'easy') attempts = 35;       // كيمسح 35، كيخلي 46 مربع عامر
  else if (difficulty === 'medium') attempts = 48; // كيمسح 48، كيخلي 33 مربع عامر
  else if (difficulty === 'hard') attempts = 56;   // كيمسح 56، كيخلي 25 مربع عامر
  else if (difficulty === 'expert') attempts = 62; // كيمسح 62، كيخلي 19 مربع (صعيب بزاف)
  
  while (attempts > 0) {
    let row = Math.floor(rng() * 9);
    let col = Math.floor(rng() * 9);
    if (board[row][col] !== 0) {
      board[row][col] = 0;
      attempts--;
    }
  }

  return { puzzle: board, solution: solution };
};